var _classCallCheck = require("/Users/night_stalker/WebstormProjects/dropMaster2/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/night_stalker/WebstormProjects/dropMaster2/node_modules/@babel/runtime/helpers/createClass");

// Generated by CoffeeScript 2.4.1
(function () {
  // Represents the error handler for DOM operations
  var XMLDOMErrorHandler;

  module.exports = XMLDOMErrorHandler =
  /*#__PURE__*/
  function () {
    "use strict";

    // Initializes a new instance of `XMLDOMErrorHandler`
    function XMLDOMErrorHandler() {
      _classCallCheck(this, XMLDOMErrorHandler);
    } // Called on the error handler when an error occurs.
    // `error` the error message as a string


    _createClass(XMLDOMErrorHandler, [{
      key: "handleError",
      value: function handleError(error) {
        throw new Error(error);
      }
    }]);

    return XMLDOMErrorHandler;
  }();
}).call(this);